/**
 * ./exercise6/Exercise6Intro.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useEffect, useState } from "react";
import "../exercise1/Exercise1Intro.css";
import { useNavigate, useLocation } from "react-router-dom";
import IconBubble from "../components/IconBubble/IconBubble";
import Star2 from "../components/icons/star2.svg";
import { API_BASE_URL } from "../config";

const Exercise6Intro = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isWarmup = location.state?.isWarmup;
  const exerciseNumber = location.state?.exerciseNumber;

  const [selectedDuration, setSelectedDuration] = useState(1.5); // Default to 5 minutes
  const [canStart, setCanStart] = useState(false);
  const [sunnyHTML, setSunnyHTML] = useState(
    `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
    Focus on the central green circle.
  </span>`
  );
  const [bubbleHeight, setBubbleHeight] = useState(100);
  const [userData, setUserData] = useState(null);

  const durations = [1]; // Only one duration option

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const isLevelUnlocked = (levelNumber) => {
    if (!userData) return false;
    if ((6 < userData.numExercisesUnlocked) || (6 === userData.numExercisesUnlocked && levelNumber <= userData.currNumLevelsUnlocked)) {
      return true;
    }
    return false;
  };

  const handleDurationClick = (duration) => {
    setSelectedDuration(duration);
  };

  const handleStartClick = () => {
    console.log(exerciseNumber);  // Check that the exercise number is logged correctly
    navigate("/exercise6workout", {
      state: {
        duration: selectedDuration,
        exerciseNumber: exerciseNumber,
        isWarmup: isWarmup
      }
    });
  };

  let handleNextNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
      Maintain focus and let your peripheral awareness expand while sustaining <b>Rhythmic Breathing</b>.
    </span>`
    );
    setBubbleHeight(150);
    setCanStart(true);
  };

  let handleNextClick = () => {
    setSunnyHTML(`<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
      Notice the disappearing points with steady attention.  
    </span>`);
  };

  const renderButton = () => {
    if (canStart) {
      return (
        <button className="guidance-and-start-button" onClick={handleStartClick}>
          Start
        </button>
      );
    } else {
      return (
        <button
          className="guidance-and-start-button"
          onClick={sunnyHTML.includes("circle") ? handleNextClick : handleNextNextClick}
        >
          Next
        </button>
      );
    }
  };


  return (
    <div className="exercise1-intro-container">
      <div className="intro-content">
      </div>
      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble
          width={620}
          height={bubbleHeight}
          HTML={sunnyHTML}
          color="FFFFFF"
          fontSize={25}
        />
      </div>
      <div className="bottom-buttons">
        <div></div>
        {renderButton()}
      </div>
    </div>
  );
};
export default Exercise6Intro;